import {
  FETCH_ESTIMATES_RATING_REQUEST,
  FETCH_ESTIMATES_RATING_SUCCESS,
  FETCH_ESTIMATES_RATING_ERROR,
} from '../../../actions/widget/estimates'
import { IDLE, FETCHED, FETCHING, ERROR } from '../../../constants/fetchStates'

const rating = (state = { status: IDLE }, action) => {
  switch (action.type) {
    case FETCH_ESTIMATES_RATING_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case FETCH_ESTIMATES_RATING_SUCCESS:
      return {
        ...state,
        rating: action.payload,
        status: FETCHED
      }
    case FETCH_ESTIMATES_RATING_ERROR:
      return {
        ...state,
        error: action.error,
        status: ERROR
      }
    default:
      return state
  }
}

export default rating
